import React from "react";
import { Batch } from "./api";

interface BatchesContextValue {
  batches: Batch[] | null;
  setBatches: (batches: Batch[]) => void;
}

export const BatchesContext = React.createContext<BatchesContextValue | null>(null);